import axios from 'axios'
import router from '@/router'

const CRAWLER_CODE = 431
let redirectingCaptcha = false

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token')
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  (response) => {
    const code = response?.data?.code
    const url = response?.config?.url || ''
    if (
      code === CRAWLER_CODE &&
      !redirectingCaptcha &&
      !url.includes('/security/captcha/verify') &&
      router.currentRoute.value.path !== '/security/captcha'
    ) {
      redirectingCaptcha = true
      const redirect = router.currentRoute.value.fullPath
      router.push({ path: '/security/captcha', query: { redirect } }).finally(() => {
        redirectingCaptcha = false
      })
    }
    return response
  },
  (error) => Promise.reject(error)
)

export function authHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export { CRAWLER_CODE }
